import styled from 'styled-components'

export const Section = styled.section`
  background-color: #ffffff;
  padding: 0;

  @media (min-width: 768px) {
    padding: 96px 0;
  }

  &.cardlist-section {
    background-color: #e9f1df;
  }

  &.disaAbletopMargin {
    padding-top: 0;
  }
  &.disaAbleBottonMargin {
    padding-bottom: 0;
  }
`
export const Grid = styled.div`
  width: 100%;
  max-width: 1312px;
  padding: 0px 24px;
  margin: 0px auto;

  @media (max-width: 576px) {
    padding: 0px 16px;
    padding: 0px 10px;
  }
`

export const Typography = styled.span`
  display: inherit;
  text-align: center;
`

export const Spacer = styled.div`
  width: 100%;
  height: 32px;
  transition: all 120ms cubic-bezier(0.165, 0.84, 0.44, 1) 0s;

  @media (min-width: 992px) {
    height: 40px;
  }
`

export const SpacerSM = styled.div`
  width: 100%;
  height: 22px;
  transition: all 120ms cubic-bezier(0.165, 0.84, 0.44, 1) 0s;

  @media (min-width: 992px) {
    height: 20px;
  }
`

export const Contained = styled.div`
  margin: 0 auto;
  max-width: 1200px;
`

export const P = styled.p`
  color: rgb(45, 47, 61);
  font-size: ${({ theme }) => theme.fontSize.base};
  line-height: 1.4;
  margin: 24px 0px 24px;

  @media (min-width: 768px) {
    font-size: ${({ theme }) => theme.fontSize.lg};
  }
`

export const H1 = styled.h1`
  color: rgb(45, 47, 61);
  font-size: ${({ theme }) => theme.fontSize.xxxl};
  font-weight: 700;
  margin: 0px 0px 12px;
  text-align: center;

  @media (max-width: 768px) {
    font-size: ${({ theme }) => theme.fontSize.xl};
    line-height: 1.2;
    padding-top: 1em;
  }
`

export const H2 = styled.h2`
  color: rgb(45, 47, 61);
  font-size: ${({ theme }) => theme.fontSize.xxl};
  font-weight: 500;
  line-height: 1.3;
  text-align: center;

  @media (max-width: 768px) {
    font-size: ${({ theme }) => theme.fontSize.xl};
    line-height: 1.2;
    padding-top: 1em;
  }
`

export const H3 = styled.h3`
  color: rgb(45, 47, 61);
  font-size: ${({ theme }) => theme.fontSize.xl};
  font-weight: 500;
  line-height: 1.6;

  @media (max-width: 768px) {
    font-size: ${({ theme }) => theme.fontSize.xl};
    line-height: 1.2;
    padding-top: 1em;
  }
`

export const H4 = styled.h4`
  color: rgb(45, 47, 61);
  font-size: ${({ theme }) => theme.fontSize.lg};
  font-weight: 500;
  line-height: 1.6;

  @media (max-width: 768px) {
    font-size: ${({ theme }) => theme.fontSize.xl};
    line-height: 1.2;
    padding-top: 1em;
  }
`

export const TextAlign = styled.span`
  display: inherit;
  text-align: left;
`
